import Manager from './containers/Manager';

export default Manager;
